import { render, staticRenderFns } from "./GrupoFamiliarBeneficiario.vue?vue&type=template&id=83cd726e&scoped=true"
import script from "./GrupoFamiliarBeneficiario.vue?vue&type=script&lang=js"
export * from "./GrupoFamiliarBeneficiario.vue?vue&type=script&lang=js"
import style0 from "./GrupoFamiliarBeneficiario.vue?vue&type=style&index=0&id=83cd726e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83cd726e",
  null
  
)

export default component.exports